export default __webpack_public_path__ + "static/media/border.845cada9.svg";